<template>
  <div v-if="only_online" class="card-wrap" :class="class_obj">
    <div class="card-header" @click="gotopage">
      <div class="card-header-left">
        <span class="iconfont icon-bushuitubiao card-icon"></span>
        <span class="card-name">{{ devdata.udname }}</span>
        <span class="card-group-tag">{{ devdata.group }}</span>
      </div>
      <div class="card-header-right">
        <span class="card-status-dot" :class="devdata.status === '在线' ? 'dot-online' : 'dot-offline'"></span>
        <span class="card-status-text">{{ devdata.status }}</span>
      </div>
    </div>

    <div v-if="show_simple === false" class="card-body" @click="gotopage">
      <div class="card-row">
        <span class="row-label">漏水状态</span>
          <span class="row-value" :class="devdata.value.leak == 1 ? 'value-warn' : 'value-active'">
            {{ devdata.value.leak == 1 ? '检测到漏水' : '正常' }}
        </span>
      </div>
      <div v-if="devdata.action && devdata.action.o1 != null" class="card-row card-row--last">
        <span class="row-label">输出开关</span>
        <span class="row-value" :class="devdata.action.o1 == 1 ? 'value-active' : 'value-inactive'">
          {{ devdata.action.o1 == 1 ? '开' : '关' }}
        </span>
      </div>
    </div>

    <div class="card-footer">
      <div class="footer-left">
        <span v-if="show_id" class="footer-id">ID: {{ devdata.did }}</span>
        <span class="footer-time">更新时间：{{ devdata.time }}</span>
      </div>
      <div class="footer-right" @click="devconfigshow = true">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="9" r="7" stroke="#94a3b8" stroke-width="1.3" opacity="0.6" />
          <circle cx="9" cy="9" r="2" fill="#94a3b8" opacity="0.6" />
          <line x1="9" y1="2" x2="9" y2="4" stroke="#94a3b8" stroke-width="1.3" opacity="0.4" />
          <line x1="9" y1="14" x2="9" y2="16" stroke="#94a3b8" stroke-width="1.3" opacity="0.4" />
          <line x1="2" y1="9" x2="4" y2="9" stroke="#94a3b8" stroke-width="1.3" opacity="0.4" />
          <line x1="14" y1="9" x2="16" y2="9" stroke="#94a3b8" stroke-width="1.3" opacity="0.4" />
        </svg>
      </div>
    </div>

    <van-action-sheet v-model="devconfigshow" :actions="actions" cancel-text="取消" @select="onSelect"
      :title="devdata.udname" class="crystal-actionsheet" />
    <DevGroup v-if="devgroupcard" :did="devdata.did" @configstatus="configstatus($event)"></DevGroup>
    <DevName v-if="devnamecard" :did="devdata.did" @configstatus="configstatus($event)"></DevName>
    <DevUnbind v-if="devunbindcard" :did="devdata.did" @configstatus="configstatus($event)"></DevUnbind>
  </div>
</template>

<script>
  import DevGroup from "../general/apidevgroup.vue";
  import DevName from "../general/apidevname.vue";
  import DevUnbind from "../general/apidevunbind.vue";

  export default {
    name: "DevCardKA1",
    components: {
      DevGroup,
      DevName,
      DevUnbind,
    },
    props: ["devdata"],
    data() {
      return {
        class_obj: this.set_card_color(),
        devgroupcard: false,
        devnamecard: false,
        devunbindcard: false,
        devconfigshow: false,
        actions: [{
            name: "更改分组",
            color: "#2dd4bf"
          },
          {
            name: "重命名",
            color: "#2dd4bf"
          },
          {
            name: "解绑",
            color: "#fb7185"
          },
        ],
      };
    },
    watch: {
      devdata: function () {
        this.class_obj = this.set_card_color();
      },
    },
    computed: {
      show_id() {
        return this.$store.state.show_id;
      },
      show_simple() {
        return this.$store.state.show_simple;
      },
      only_online() {
        if (this.$store.state.only_online === false) return true;
        else return this.devdata.status === "在线" ? true : false;
      },
    },
    methods: {
      configstatus(statu) {
        this.devgroupcard = false;
        this.devnamecard = false;
        this.devunbindcard = false;
        if (statu === true) {
          this.$toast.success("设置成功");
        }
        this.$emit("cardflash", true);
      },
      onSelect(item) {
        this.devconfigshow = false;
        if (item.name === "重命名") {
          this.devnamecard = true;
        } else if (item.name === "更改分组") {
          this.devgroupcard = true;
        } else if (item.name === "解绑") {
          this.devunbindcard = true;
        }
      },
      set_card_color() {
        if (this.devdata.status === "离线") {
          return { "card-off": true };
        } else if (this.devdata.err && this.devdata.err[0] !== 0) {
          return { "card-warning": true };
        } else {
          return { "card-on": true };
        }
      },
      gotopage() {
        this.$router.push({
          name: "KA1page",
          query: { did: this.devdata.did },
        });
      },
      dev_one() {
        this.$emit("cardflash", true);
      },
    },
  };
</script>

<style>
  .crystal-actionsheet .van-action-sheet__header {
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
  }
</style>

<style scoped>
  .card-wrap {
    background: #ffffff;
    border-radius: 16px;
    padding: 14px 16px 10px;
    margin-bottom: 10px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 6px 20px rgba(0, 0, 0, 0.04);
    transition: transform 0.2s, box-shadow 0.2s;
    border-left: 4px solid #2dd4bf;
    cursor: pointer;
  }

  .card-wrap:active {
    transform: scale(0.98);
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
  }

  .card-off {
    border-left-color: #cbd5e1;
    opacity: 0.7;
  }

  .card-warning {
    border-left-color: #fb7185;
  }

  .card-on {
    border-left-color: #2dd4bf;
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .card-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 1;
  }

  .card-icon {
    font-size: 22px;
    color: #2dd4bf;
    flex-shrink: 0;
  }

  .card-off .card-icon {
    color: #94a3b8;
  }

  .card-name {
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .card-group-tag {
    font-size: 10px;
    color: #94a3b8;
    background: #f1f5f9;
    padding: 2px 8px;
    border-radius: 6px;
    flex-shrink: 0;
    font-weight: 500;
  }

  .card-header-right {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    margin-left: 8px;
  }

  .card-status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }

  .dot-online {
    background: #2dd4bf;
  }

  .dot-offline {
    background: #94a3b8;
  }

  .card-status-text {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 500;
  }

  .card-body {
    padding: 4px 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 4px;
  }

  .card-row--last {
    padding-bottom: 2px;
  }

  .row-label {
    font-size: 13px;
    color: #94a3b8;
    font-weight: 400;
  }

  .row-value {
    font-size: 14px;
    color: #475569;
    font-weight: 500;
  }

  .value-active {
    color: #0d9488;
  }

  .value-inactive {
    color: #94a3b8;
  }

  .value-warn {
    color: #fb7185;
  }

  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f1f5f9;
    padding-top: 8px;
    margin-top: 4px;
  }

  .footer-left {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
  }

  .footer-id {
    font-size: 11px;
    color: #cbd5e1;
    font-weight: 400;
  }

  .footer-time {
    font-size: 11px;
    color: #cbd5e1;
    font-weight: 400;
  }

  .footer-right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    transition: background 0.15s;
    cursor: pointer;
    flex-shrink: 0;
  }

  .footer-right:active {
    background: #f1f5f9;
  }
</style>
